// hooks/useAds.ts
import { useQuery } from '@tanstack/react-query'
import { fetchAds } from '@/services/adsService' // Hàm fetch từ service
import { Advertisement } from '@/models/ads.model'

export const useAds = () => {
  const { data, error, isLoading, isError } = useQuery<Advertisement[], Error>({
    queryKey: ['ads'],
    queryFn: fetchAds,
    staleTime: 5 * 60 * 1000,
  })

  return { data, error, isLoading, isError }
}
